import { Progress } from 'antd';
import React from 'react';
import TimeSteps, { ICourseStep } from './timeSteps';

interface ICourseOverviewProps {
  courseName: string;
  topicName?: string;
  steps: ICourseStep[];
  progress: number;
  currentStep: number;
}

const CourseOverview: React.FunctionComponent<ICourseOverviewProps> = ({
  courseName,
  topicName = '',
  steps,
  progress,
  currentStep,
}) => (
  <div className="course-left-overview">
    <div className="course-name">{courseName}</div>
    <div className="topic-name">{topicName}</div>
    <div className="course-progress-bar">
      <Progress
        format={(percent) => `${percent}%`}
        className="round-progress"
        strokeWidth={9}
        strokeColor="#F26927"
        trailColor="#fcdbc9"
        type="circle"
        width={53}
        percent={progress}
      />
    </div>
    <TimeSteps steps={steps} current={currentStep} />
  </div>
);

export default CourseOverview;
